import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { ref, update, onValue } from "firebase/database";
import { X, Settings, Target } from 'lucide-react';
import Swal from 'sweetalert2';
import './Trap.css';

const TrapModal = ({ user, onClose }) => {
  const [presets, setPresets] = useState({});
  const [activeTraps, setActiveTraps] = useState([]);
  const [manualTask, setManualTask] = useState({ task: '', amt: '', rate: '' });
  const [editingPreset, setEditingPreset] = useState(null);

  useEffect(() => {
    const userTrapRef = ref(db, `users/${user.id}/traps`);
    onValue(userTrapRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setPresets(data.presets || {});
        setActiveTraps(data.active || []);
      }
    });
  }, [user.id]);

  // Settings button logic for 5 tasks per preset
  const openEditModal = (num) => {
    const current = presets[num] || { name: `Preset ${num}`, tasks: Array(5).fill({ tNo: '', amt: '', rate: '' }) };
    setEditingPreset({ num, ...current });
  };

  const savePresetConfig = () => {
    update(ref(db, `users/${user.id}/traps/presets/${editingPreset.num}`), {
      name: editingPreset.name,
      tasks: editingPreset.tasks
    });
    setEditingPreset(null);
    Swal.fire({ title: 'Saved!', icon: 'success', background: '#1a1a1a', color: '#fff' });
  };

  // Jab preset card par click ho to saare tasks active list mein chale jayen
  const deployPreset = (num) => {
    const preset = presets[num];
    if (!preset || !preset.tasks) return;
    
    // Filter out empty rows
    const validTasks = preset.tasks
      .filter(t => t.tNo && t.amt)
      .map(t => ({ task: t.tNo, amt: t.amt, rate: t.rate, id: Date.now() + Math.random() }));

    if (validTasks.length === 0) return;

    const newActiveList = [...activeTraps, ...validTasks];
    update(ref(db, `users/${user.id}/traps`), { active: newActiveList });
  };

  const removeTrap = (id) => {
    const filtered = activeTraps.filter(t => t.id !== id);
    update(ref(db, `users/${user.id}/traps`), { active: filtered });
  };

  return (
    <div className="trap-overlay">
      <div className="trap-manager">
        <div className="trap-header-main">
          <h2>Trap Manager: <span className="gold-text">{user.username}</span></h2>
          <X className="close-icon" onClick={onClose} />
        </div>

        <div className="trap-grid">
          <div className="trap-left">
            <h3>CLOUD PRESETS</h3>
            <div className="preset-list">
              {[1, 2, 3, 4, 5].map((num) => (
                <div key={num} className="preset-card" onClick={() => deployPreset(num)}>
                  <div className="preset-num">{num}</div>
                  <div className="preset-info">
                    <p className="p-title">{presets[num]?.name || `Preset ${num} (Empty)`}</p>
                  </div>
                  <Settings size={18} className="settings-btn" onClick={(e) => { e.stopPropagation(); openEditModal(num); }} />
                </div>
              ))}
            </div>

            <div className="manual-section">
              <h3>QUICK MANUAL ADD</h3>
              <div className="manual-inputs">
                <input placeholder="Task" value={manualTask.task} onChange={e => setManualTask({...manualTask, task: e.target.value})} />
                <input placeholder="Amt" value={manualTask.amt} onChange={e => setManualTask({...manualTask, amt: e.target.value})} />
                <input placeholder="Rate" value={manualTask.rate} onChange={e => setManualTask({...manualTask, rate: e.target.value})} />
                <button className="add-btn-yellow" onClick={() => {
                   const newActive = [...activeTraps, { ...manualTask, id: Date.now() }];
                   update(ref(db, `users/${user.id}/traps`), { active: newActive });
                   setManualTask({ task: '', amt: '', rate: '' });
                }}>ADD</button>
              </div>
            </div>
          </div>

          <div className="trap-right">
            <h3>ACTIVE TRAPS ({activeTraps.length})</h3>
            <div className="active-list">
              {activeTraps.map((t) => (
                <div key={t.id} className="active-trap-card">
                  <div className="trap-indicator"></div>
                  <div className="trap-details">
                    <h4>TASK {t.task}</h4>
                    <p>${t.amt} | {t.rate}%</p>
                  </div>
                  <X size={14} className="del-trap" onClick={() => removeTrap(t.id)} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* --- NESTED MODAL FOR SETTINGS --- */}
      {editingPreset && (
        <div className="nested-overlay">
          <div className="nested-modal">
            <div className="nested-header">
              <h3>Edit {editingPreset.name}</h3>
              <X className="close-icon" onClick={() => setEditingPreset(null)} />
            </div>
            <input 
              className="preset-name-input" 
              placeholder="Preset Name" 
              value={editingPreset.name} 
              onChange={e => setEditingPreset({...editingPreset, name: e.target.value})}
            />
            <div className="task-labels">
               <span>Task No</span><span>Amount</span><span>Rate %</span>
            </div>
            {editingPreset.tasks.map((task, idx) => (
              <div key={idx} className="task-row">
                <input type="number" value={task.tNo} onChange={e => {
                  let newTasks = [...editingPreset.tasks];
                  newTasks[idx] = {...newTasks[idx], tNo: e.target.value};
                  setEditingPreset({...editingPreset, tasks: newTasks});
                }} />
                <input type="number" value={task.amt} onChange={e => {
                  let newTasks = [...editingPreset.tasks];
                  newTasks[idx] = {...newTasks[idx], amt: e.target.value};
                  setEditingPreset({...editingPreset, tasks: newTasks});
                }} />
                <input type="number" value={task.rate} onChange={e => {
                  let newTasks = [...editingPreset.tasks];
                  newTasks[idx] = {...newTasks[idx], rate: e.target.value};
                  setEditingPreset({...editingPreset, tasks: newTasks});
                }} />
              </div>
            ))}
            <button className="save-changes-btn" onClick={savePresetConfig}>SAVE CHANGES</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrapModal;